import api from "@/config/api"

export default {
  namespaced: true,
  state: () => ({
    waitingCount: 0
  }),
  mutations: {
    setWaitingCount(state, count) {
      state.waitingCount = count
    }
  },
  actions: {
    async fetchWaitingCount(context) {
      try {
        const response = await api.get("/feedbacks/waiting_count")
        context.commit("setWaitingCount", response.data.count ?? 0)
      } catch (error) {
        context.commit("setWaitingCount", 0)
      }
    }
  }
}
